export default {
  EN:{
  All: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://static.stgairasia.com/cosmos/images/product-tiles/showall_flat.svg",
    newTab: "FALSE",
    position: "1",
    productID: "All",
    productTile: "All",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Halal: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt0060f0d7f6b703f5/607652717ec0d95ee902f4d5/HALAL.png?quality=50&width=45&format=webp",
    newTab: "FALSE",
    position: "3",
    productID: "Halal",
    productTile: "Halal",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Asian: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltc9d0c1e4522cd88a/6076528f1de09d61579f66b0/Asian.png?quality=50&width=45&format=webp",
    newTab: "FALSE",
    position: "2",
    productID: "Asian",
    productTile: "Asian",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Healthy: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt71e284cf6a7b3b48/6076529bb1aadc4a2ab2586c/Healthy.png?quality=50&width=45&format=webp",
    newTab: "FALSE",
    position: "1",
    productID: "Healthy",
    productTile: "Healthy",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Western: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt6be5bd26c01dca37/607652bd93a327076df3a4b2/Western.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "2",
    productID: "Western",
    productTile: "Western",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Vegetarian: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltdf517afb515e952d/609ba31c460f0f28dcd7386c/vegetarianpng_1620812571777.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "2",
    productID: "Vegetarian",
    productTile: "Vegetarian",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Dessert: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blta60bfef6553cb218/607652affb66d367c151ac1d/Dessert.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "2",
    productID: "Dessert",
    productTile: "Dessert",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Beverages: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt27ad4cf08de222d8/607652c7f43cbb6d4a0f8cbe/Beverages.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "2",
    productID: "Beverages",
    productTile: "Beverages",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
  Grocery: {
    adhocMessage: "",
    attractText: "",
    cnDisclaimerLine1: "",
    cnDisclaimerLine2: "",
    cnDisclaimerURL: "",
    countDownTimer: "",
    customPropertiesTile: {
      "data-tile": "other-tile",
    },
    gtmParameters: "",
    iconUrl:
      "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltf665fca5e67ffb28/624e2ec77d3f38318b0bb295/foodpng_1649290950315.png?quality=50&width=45&format=webp",
    newTab: "TRUE",
    position: "5",
    productID: "Grocery",
    productTile: "Grocery",
    redirectCompanyName: "",
    redirectCompanyURL: "",
    redirectionUrl: "",
    showSearchWidget: "TRUE",
  },
},
  TH:{
    All: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://static.stgairasia.com/cosmos/images/product-tiles/showall_flat.svg",
      newTab: "FALSE",
      position: "1",
      productID: "All",
      productTile: "All",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Noodles: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltb4772153b5770dbb/6268d3d152aaad1f51f969c1/noodlepng_1651037136518.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "2",
      productID: "Noodles",
      productTile: "Noodles",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    "Thai Food" : {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt9b40f738b306e861/6268d443a1b42d323974004e/somtumpng_1651037250582.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "3",
      productID: "Thai Food",
      productTile: "Thai Food",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Japanese: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt5a878ec46b6019c1/6268bc9a92a203387da3ad52/japanesepng_1651031193480.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "4",
      productID: "Japanese",
      productTile: "Japanese",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    "Western Food ": {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltcb8e53acfa9cfc03/6268d7d140ae0a34757d5458/westernpng_1651038160732.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Western Food",
      productTile: "Western Food",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Juice: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt37cd4ab931421cc0/6268d4b901f79220b506594b/juicepng_1651037369167.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "5",
      productID: "Juice",
      productTile: "Juice",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Bakery: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt13297bc4d78d6ddf/6268d52813e13a1f46bd68cf/bakerypng_1651037480256.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "6",
      productID: "Bakery",
      productTile: "Bakery",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Coffee: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt94293e1ccf93a66c/6268d493051cec207dd4236e/coffeepng_1651037330485.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "7",
      productID: "Coffee",
      productTile: "Coffee",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    "Chinese ": {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt0f7b8b8e52192918/6268d40b97814c34727d44c6/chinesepng_1651037194935.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "6",
      productID: "Chinese",
      productTile: "Chinese",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
  },
  TH_TH:{
    All: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://static.stgairasia.com/cosmos/images/product-tiles/showall_flat.svg",
      newTab: "FALSE",
      position: "1",
      productID: "All",
      productTile: "ทั้งหมด",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Noodles: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltb4772153b5770dbb/6268d3d152aaad1f51f969c1/noodlepng_1651037136518.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Noodles",
      productTile: "ก๋วยเตี๋ยว",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    "Chinese": {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt0f7b8b8e52192918/6268d40b97814c34727d44c6/chinesepng_1651037194935.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "6",
      productID: "Chinese",
      productTile: "อาหารจีน",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    "Thai Food" : {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt9b40f738b306e861/6268d443a1b42d323974004e/somtumpng_1651037250582.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Thai Food",
      productTile: "อาหารไทย",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Japanese: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt5a878ec46b6019c1/6268bc9a92a203387da3ad52/japanesepng_1651031193480.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Japanese",
      productTile: "อาหารญี่ปุ่น",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    "Western Food ": {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltcb8e53acfa9cfc03/6268d7d140ae0a34757d5458/westernpng_1651038160732.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Western Food",
      productTile: "อาหารตะวันตก",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Juice: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt37cd4ab931421cc0/6268d4b901f79220b506594b/juicepng_1651037369167.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Juice",
      productTile: "เครื่องดื่ม/น้ำผลไม้",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Bakery: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt13297bc4d78d6ddf/6268d52813e13a1f46bd68cf/bakerypng_1651037480256.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Bakery",
      productTile: "ขนม",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Coffee: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt94293e1ccf93a66c/6268d493051cec207dd4236e/coffeepng_1651037330485.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Coffee",
      productTile: "เครื่องดื่มกาแฟ",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
  },
  ID:{
    All: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://static.stgairasia.com/cosmos/images/product-tiles/showall_flat.svg",
      newTab: "FALSE",
      position: "1",
      productID: "All",
      productTile: "Semua",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Halal: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt0060f0d7f6b703f5/607652717ec0d95ee902f4d5/HALAL.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Halal",
      productTile: "Makanan Halal",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Asian: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltc9d0c1e4522cd88a/6076528f1de09d61579f66b0/Asian.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Asian",
      productTile: "Makanan Asia",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Healthy: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt71e284cf6a7b3b48/6076529bb1aadc4a2ab2586c/Healthy.png?quality=50&width=45&format=webp",
      newTab: "FALSE",
      position: "1",
      productID: "Healthy",
      productTile: "Makanan Sehat",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Western: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt6be5bd26c01dca37/607652bd93a327076df3a4b2/Western.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Western",
      productTile: "Makanan Barat",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Vegetarian: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltdf517afb515e952d/609ba31c460f0f28dcd7386c/vegetarianpng_1620812571777.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Vegetarian",
      productTile: "Vegetarian",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Dessert: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blta60bfef6553cb218/607652affb66d367c151ac1d/Dessert.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Dessert",
      productTile: "Dessert",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
    Beverages: {
      adhocMessage: "",
      attractText: "",
      cnDisclaimerLine1: "",
      cnDisclaimerLine2: "",
      cnDisclaimerURL: "",
      countDownTimer: "",
      customPropertiesTile: {
        "data-tile": "other-tile",
      },
      gtmParameters: "",
      iconUrl:
        "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blt27ad4cf08de222d8/607652c7f43cbb6d4a0f8cbe/Beverages.png?quality=50&width=45&format=webp",
      newTab: "TRUE",
      position: "2",
      productID: "Beverages",
      productTile: "Minuman",
      redirectCompanyName: "",
      redirectCompanyURL: "",
      redirectionUrl: "",
      showSearchWidget: "TRUE",
    },
  },
}
